import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  func, arrayOf
} from 'prop-types';
import { Link } from 'react-router-dom';

import BrowseSurveyParts from '../../../SurveySchemas/BrowseSurveyParts';
import SelectedSurveySchemaParts from './selectedSurveySchemaParts';
import { updateSurveySchemaPartsAction } from '../../../../actions';
import { previousLocationType, SurveySchemaEditorType, surveySchemaMetadataType } from '../../../../constants/types';
import withRouter from '../../../WithRouter';

import editorStyles from '../../editor.module.css';
import { routes } from '../../../../constants';
import { withPreviousLocation } from '../../../PreviousLocationProvider';
import { withLang, langType } from '../../../../i18n';
import { setDocumentTitle } from '../../../../util';

class AddSurveySchemaParts extends Component {
  constructor(props) {
    super(props);
    this.onSelectSchemaPart = this.onSelectSchemaPart.bind(this);
    this.onRemoveSchemaPart = this.onRemoveSchemaPart.bind(this);
    this.onUpdateSchemaParts = this.onUpdateSchemaParts.bind(this);
    this.onSave = this.onSave.bind(this);
    this.entryReferer = this.props.previousLocation && this.props.previousLocation.pathname
      ? this.props.previousLocation.pathname
      : routes.surveySchemas.schemas.index;

    this.state = {
      selectedSchemaParts: props.initialSchemaParts
    };
  }

  onSave() {
    const { dispatchUpdateSchemaParts } = this.props;
    dispatchUpdateSchemaParts(this.state.selectedSchemaParts);
  }

  onSelectSchemaPart(schemaPart) {
    const { selectedSchemaParts } = this.state;
    this.setState({ selectedSchemaParts: [...selectedSchemaParts, schemaPart] });
  }

  onRemoveSchemaPart(id) {
    const { selectedSchemaParts } = this.state;
    this.setState({ selectedSchemaParts: selectedSchemaParts.filter((s) => s.id !== id) });
  }

  onUpdateSchemaParts(schemaParts) {
    this.setState({ selectedSchemaParts: schemaParts });
  }

  render() {
    const { selectedSchemaParts } = this.state;
    const { translate: t, surveySchema } = this.props;
    setDocumentTitle(t('editor.surveySchemaParts.chooseSchemaParts'));

    return (
      <div className="page-container">
        <h2>{t('editor.surveySchemaParts.chooseSchemaParts')}</h2>
        <SelectedSurveySchemaParts
          onRemoveSchemaPart={this.onRemoveSchemaPart}
          onUpdateSchemaParts={this.onUpdateSchemaParts}
          schemaParts={selectedSchemaParts}
        />
        <BrowseSurveyParts
          selectable
          selectedParts={selectedSchemaParts}
          onSelectPart={this.onSelectSchemaPart}
          lockedType={surveySchema.type}
        />
        <div className={editorStyles.navigation}>
          <Link className="button--action" to={this.entryReferer}>
            {t('common.cancel')}
          </Link>
          <Link
            className="button--action"
            to={this.entryReferer}
            onClick={this.onSave}
          >
            {t('editor.surveySchemaParts.selectSchemaParts')}
          </Link>
        </div>
      </div>
    );
  }
}

AddSurveySchemaParts.propTypes = {
  dispatchUpdateSchemaParts: func.isRequired,
  previousLocation: previousLocationType.isRequired,
  initialSchemaParts: arrayOf(surveySchemaMetadataType).isRequired,
  surveySchema: SurveySchemaEditorType.isRequired,
  translate: langType.translate.isRequired
};

const mapStateToProps = ({ surveySchema }) => ({
  initialSchemaParts: surveySchema.surveySchemaOptions.surveySchemaParts,
  surveySchema: surveySchema.surveySchemaOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateSchemaParts: (surveySchemaParts) =>
    dispatch(updateSurveySchemaPartsAction(surveySchemaParts))
});

export default withPreviousLocation(withRouter(withLang(connect(mapStateToProps, mapDispatchToProps)(AddSurveySchemaParts))));
